import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private matSnackbar: MatSnackBar,
    private translationService: TranslateService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {

        //if (error.status === 401 || error.status === 403) { this.auth.logout({ logoutParams: { returnTo: window.location.origin + '/login' } }); } return throwError(() => error);
        if (error instanceof HttpErrorResponse) {
          if (error.status === 403) {
            this.matSnackbar.open(this.translationService.instant('errors.admin-access'), 'OK');
          }
        }
        return throwError(() => error);
      })
    );
  }
}
